import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-weee-system-retail-vs-municipalities-vs-other-filters',
  templateUrl: './weee-system-retail-vs-municipalities-vs-other-filters.component.html',
  styleUrls: ['./weee-system-retail-vs-municipalities-vs-other-filters.component.scss']
})
export class WeeeSystemRetailVsMunicipalitiesVsOtherFiltersComponent implements OnInit {

  @Input()
  years!: number[];

  searchForm = this.formBuilder.group({
    year: [''],
    order: ['desc'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({year: this.yearControl.value, order: this.orderControl.value} as IntelligenceSearchInterface);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.orderControl.setValue(null);
    this.search.emit({year: this.yearControl.value} as IntelligenceSearchInterface);
  }

}
